import { useEffect, useState } from "react";
import { fetchPostalCodeDetails } from "../../utils/functions/fetchPostalCodeDetails";
import { isValidPostalCode } from "../../utils/functions/validatePostalCode";
import FieldDescription from "../tools/FieldDescription";
import { IndividualPersonType } from "../../static/types/commonTypes/individualType";
import { LegalEntityType } from "../../static/types/commonTypes/legalEntityType";
import { RegistredAdressType } from "../../static/types/commonTypes/registredAdressType";
import { HeadOfficeAddressType } from "../../static/types/commonTypes/headOfficeAddressType";
import { AddressType } from "../../static/types/commonTypes/addressType";
import { DateOfBirthAndCityType } from "../../static/types/commonTypes/dateOfBirthAndCity";
import { DeathRelatedInfoType } from "../../static/types/commonTypes/deathRelatedInfoType";
import { NotaryContactType } from "../../static/types/commonTypes/notaryContactType";

const PostalCodeField: React.FC<{
    checked: boolean,
    errors: { [key: string]: string }
    postalCode: string;
    onChange: (data: Partial<
        | IndividualPersonType
        | LegalEntityType
        | RegistredAdressType
        | AddressType
        | DateOfBirthAndCityType
        | DeathRelatedInfoType
        | NotaryContactType 
    >) => void;
    style?: React.CSSProperties;
}> = ({
    checked,
    errors,
    postalCode,
    onChange,
    style
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPostalCodeData = async () => {
            if ( isValidPostalCode(postalCode) ) {
                setIsLoading(true);
                setError(null);

                try {
                    const postalDetails = await fetchPostalCodeDetails(postalCode);
                    
                    if (postalDetails) {
                        const updateData: Partial<
                        IndividualPersonType |
                        LegalEntityType |
                        RegistredAdressType |
                        HeadOfficeAddressType |
                        AddressType |
                        DateOfBirthAndCityType |
                        NotaryContactType
                    > = {
                            city: postalDetails.city,
                            cities: postalDetails.cities,
                            registrationOffice: postalDetails.registrationOffice
                        };
                        onChange(updateData);
                    } else {
                        setError("Aucune information trouvée pour ce code postal");
                    }
                } catch (err) {
                    setError("Erreur de récupération des informations");
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchPostalCodeData();
    }, [ postalCode ]);

    return (
    <>
    <div className="row mb-3" style={style}>
        <label htmlFor = "postalCode" className = "col-sm-2 col-form-label">
            Code postal <strong className="text-danger">*</strong>
        </label>
        <div className="col-sm-4">
            <input
                className = {`description-input form-control ${ checked && errors.postalCode ? 'is-invalid' : ''}`}
                type = "text"
                id = "postalCode"
                value = { postalCode }
                onChange = {(e) => {
                    if(/^\d{0,5}$/.test(e.target.value)){
                        onChange({ postalCode: e.target.value })
                    }
                }}
            />
            { checked && errors.postalCode && <div className="invalid-feedback"> {errors.postalCode} </div> }
            <FieldDescription description = "Pour une adresse hors France ou Dom-Tom écrire : 00000" />
        </div>
    </div>
    </>
    );
};

export default PostalCodeField